import router from  '../../router/index'
import apiService from '../../services/api.service'
import { CancelToken } from '../../services/api.service'
import * as types from '../types'

const state = {
    positionData: null,
    connectionAttempts: 10,
    currentConnectionAttempt: 0,
    cancel: null,
    requestAfter: 5000,
    positionLoaderTimeOut: null
};

const getters = {
    tripData: state => {
        if(state.positionData) {
            return state.positionData.trip ? state.positionData.trip : null;
        }
    }
};

const actions = {
    [types.GET_POSITION_DATA]: ({commit, dispatch, state, rootState, getters}) => {

        let requestData = {
            url: 'api/taxi/driver/position',
            method: 'POST',
            cancelToken: new CancelToken((cancel)=> {
                state.cancel = cancel;
            })
        };

        apiService.sendRequest(requestData).then((resp) => {
            if(getters.isAuthenticated){
                commit(types.SET_POSITION_DATA, resp.data.data);
            }
            state.currentConnectionAttempt = 0;
        }).catch(err => {
            if(err.name === 'NetworkError'){
                state.currentConnectionAttempt ++;
                if(state.currentConnectionAttempt > state.connectionAttempts){
                    dispatch(types.AUTH_LOGOUT).then(()=>{
                        router.push({name: 'authorization'})
                    }).catch(err =>{
                        console.log(err);
                    });
                }
            }
        }).finally(()=>{
            if(getters.isAuthenticated){
                state.positionLoaderTimeOut = setTimeout(()=> dispatch(types.GET_POSITION_DATA), state.requestAfter);
            }
        })
    },
};

const mutations = {
    [types.SET_POSITION_DATA]: (state, positionData) =>{
        state.positionData = positionData;
    },

    [types.CLEAR_POSITION_LOADER_TIMEOUT]: (state) =>{
        clearTimeout(state.positionLoaderTimeOut);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}